<template>
	<div class="wrap">
		<div class="header">
			<!-- 已有账号，去登录 -->
		</div>
		<div class="login">
			<div class="logo">
				新用户注册
			</div>
			<div class="main">
				<div class="main-input">
					<div class="inputimg">
						<img src="../assets/img/icon6.png" alt="">
					</div>
					<div class="inputfield">
						<van-field v-model="user.user_tel" type="tel" placeholder="输入您的手机号" maxlength="11">
							<template #button>
								<van-button class="send_code" :disabled="sendsmscode" size="small" type="info"
									@click="sendcode">
									<span v-if="sendsmscode == false">发送验证码</span><span v-else>{{count}}s后重新发送</span>
								</van-button>
							</template>
						</van-field>
					</div>
				</div>
				<div class="main-input ">
					<div class="inputimg inputimg1">
						<img src="../assets/img/icon7.png" alt="">
					</div>
					<div>
						<van-field v-model="user.smscode" center placeholder="输入验证码">
						</van-field>
					</div>
				</div>
				<div class="main-input">
					<div class="inputimg">
						<img src="../assets/img/icon5.png" alt="">
					</div>
					<div>
						<van-field v-model="user.user_pwd" type="password" placeholder="设置登录密码" maxlength="18" />
					</div>
				</div>
				<div class="main-input">
					<div class="inputimg">
						<img src="../assets/img/icon5.png" alt="">
					</div>
					<div>
						<van-field v-model="user.user_repeat_pwd" type="password" placeholder="确认登录密码" />
					</div>
				</div>
				<div class="main-input">
					<div class="inputimg">
						<img src="../assets/img/code_img.png" alt="">
					</div>
					<div>
						<van-field v-model="user.user_sn" placeholder="输入邀请码领红包" />
					</div>
				</div>
				<div class="consent ">
					<div class="consentimg" v-if="agree==1" @click="changagree"><img src="../assets/img/pitchon.png"
							alt=""></div>
					<div class="consentimg" v-if="agree==0" @click="changagree"><img src="../assets/img/ispitchon.png"
							alt=""></div>
					<div style="margin-left: 0.266rem;">已阅读并同意</div>
					<div class="agreement" @click="goto">《平台注册协议》</div>
				</div>
				<div style="margin-top:1.333rem">
					<van-button block type="info" round @click="onSubmit">
						立即注册
					</van-button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		userregistershareModule
	} from "../request/myFreecharge";
	import {
		explainsettingModule
	} from "../request/myFreecharge";
	import {
		Toast
	} from 'vant';
	const TIME_COUNT = 120;
	export default {
		data() {
			return {
				user: {
					user_tel: '',
					user_pwd: '',
					user_repeat_pwd: '',
					smscode: '',
					user_sn: this.$route.query.userSn || ''
				},
				errMsg: {
					user_tel: '',
					user_pwd: '',
					user_repeat_pwd: '',
					smscode: '',
				},
				sendsmscode: false,
				count: 0,
				timer: null,
				agree: 0,
				// isGreen:true,
				// regTime:20,
				// registActive:false,
				// registTimer:null,
				//设备类型1：Android，2：IOS 
				deviceType: 1,
				explainContent: '',
				explainTitle: ''
			}
		},
		created: async function() {},
		methods: {
			async sendcode() {
				this.checkTel()
				if (this.checkTel() == false) {
					return
				}
				await userregistershareModule.addmembersendcodeshare(1, this.user.user_tel, 1).then((response) => {
					// console.log(response)
					switch (response.data.code) {
						case 100:
							Toast({
								message: "已发送",
								position: 'center',
							});
							this.sendsmscode = true
							if (!this.timer) {
								this.count = TIME_COUNT;
								this.timer = setInterval(() => {
									if (this.count > 0 && this.count <= TIME_COUNT) {
										this.count--;
									} else {
										this.sendsmscode = false
										clearInterval(this.timer);
										this.timer = null;
									}
								}, 1000);
							}
							break;
						case 101:
							Toast({
								message: "获取失败",
								position: 'center',
							});
							break;
						case 103:
							Toast({
								message: "手机号格式错误",
								position: 'center',
							});
							break;
						case 104:
							Toast({
								message: "手机号已注册过",
								position: 'center',
							});
							break;
						case 100001:
							Toast({
								message: "网络连接异常,请稍后重试",
								position: 'center',
							});
							break;
					}
				}).catch(() => {})
			},
			async onSubmit() {
				this.checkTel()
				this.checkPsd()
				this.checkRepeatPwd()
				this.checkCode()
				if (this.agree == 0) {
					Toast({
						message: "请阅读《平台注册协议》",
						position: 'center',
					});
					return
				}
				if (this.checkTel() && this.checkPsd() && this.checkRepeatPwd() && this.checkCode() == true) {
					// this.$route.query.puserID=1630333978720
					// this.$route.query.devicetoken=111
					await userregistershareModule.userregistershare(this.user.user_tel, this.$md5(this.$md5(this.user
						.user_pwd)), this.deviceType, '', this.user.smscode, this.$route.query.puserID, this.$route.query.userSn).then((
						response) => {
						// console.log(response)
						switch (response.data.code) {
							case 100: {
								Toast({
									message: "注册成功",
									position: 'center',
								});
								this.user.user_tel = ''
								this.user.user_pwd = ''
								this.user.smscode = ''
								this.user.user_repeat_pwd = ''
								this.user.user_sn = ''
								this.sendsmscode = false
								this.count = 120
								this.sendsmscode = false
								clearInterval(this.timer);
								this.timer = null;
								this.$router.push({
									path: '/download',
									query: {
										marktype: 1,
									}
								})
							}
							break;
						case 101:
							Toast({
								message: "注册失败",
								position: 'center',
							});
							break;
						case 102:
							break;
						case 103:
							Toast({
								message: "验证码错误",
								position: 'center',
							});
							break;
						case 104:
							Toast({
								message: "验证码超时",
								position: 'center',
							});
							break;
						case 105:
							Toast({
								message: "用户已存在",
								position: 'center',
							});
							break;
						case 100001:
							Toast({
								message: "网络连接异常,请稍后重试",
								position: 'center',
							});
							break;
						}
					}).catch(() => {})
				}
			},
			changagree() {
				if (this.agree == 0) {
					this.agree = 1
				} else {
					this.agree = 0
				}
			},
			checkTel() {
				if (this.user.user_tel == '') {
					this.errMsg.user_tel = "手机号不能为空! "
					Toast({
						message: this.errMsg.user_tel,
						position: 'center',
					});
					return false
				} else if (!(/^1[3456789]\d{9}$/.test(this.user.user_tel))) {
					this.errMsg.user_tel = "请输入正确的手机号! "
					Toast({
						message: this.errMsg.user_tel,
						position: 'center',
					});
					return false
				} else {
					this.errMsg.user_tel = ""
					return true
				}
			},
			//判断
			checkPsd() {
				if (this.user.user_pwd == '') {
					this.errMsg.user_pwd = '密码不能为空!'
					Toast({
						message: this.errMsg.user_pwd,
						position: 'center',
					});
					return false
				} else if (!(/^(?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]{6,18}$/.test(this.user.user_pwd))) {
					this.errMsg.user_pwd = '请输入6-18位数字字母混合的密码!'
					Toast({
						message: this.errMsg.user_pwd,
						position: 'center',
					});
					return false
				} else {
					this.errMsg.user_pwd = ''
					return true
				}
			},
			// 密码判断
			checkRepeatPwd() {
				if (this.user.user_repeat_pwd == '') {
					this.errMsg.user_repeat_pwd = "确认密码不能为空! "
					Toast({
						message: this.errMsg.user_repeat_pwd,
						position: 'center',
					});
					return false
				} else if (this.user.user_repeat_pwd != this.user.user_pwd) {
					this.errMsg.user_repeat_pwd = "两次密码不一致! "
					Toast({
						message: this.errMsg.user_repeat_pwd,
						position: 'center',
					});
					return false
				} else {
					this.errMsg.user_repeat_pwd = ""
					return true
				}
			},
			// 验证码判断
			checkCode() {
				if (this.user.smscode == '') {
					this.errMsg.smscode = "验证码不能为空!"
					Toast({
						message: this.errMsg.smscode,
						position: 'center',
					});
					return false
				} else {
					this.errMsg.smscode = ""
					return true
				}
			},
			goto() {
				this.$router.push({
					path: '/about',
					query: {
						explainID: 1,
					}
				})
			},
			async getInfo() {
				await explainsettingModule.explainsettingdetailshare(1).then((response) => {
					// console.log(response)
					switch (response.data.code) {
						case 100:
							this.explainContent = response.data.result.explainContent
							this.explainTitle = response.data.result.explainTitle
							break;
						case 101:
							Toast({
								message: "获取失败",
								position: 'center',
							});
							break;
						case 100001:
							Toast({
								message: "网络接连异常，请稍后再试",
								position: 'center',
							});
							break;
					}
				}).catch(() => {})
			},
		},
	}
</script>
<style scoped>
</style>
<style scoped>
	body,
	html {
		background-color: #fff !important;
		min-height: 100%;
	}

	.wrap {
		width: 86.336%;
		margin: 0 auto;

	}

	.header {
		font-weight: 500;
		text-align: right;
		color: #323232;
		font-size: 0.4rem;
		padding-top: 0.266rem;
	}

	.logo {
		font-weight: 800;
		text-align: left;
		color: #323232;
		font-size: 0.75rem;
	}

	.main {
		margin-top: 1.73rem;
	}

	.main-input {
		display: flex;
		border-bottom: 1px solid #EBEBEB;
		margin-top: 0.5rem;
	}

	.inputfield {
		width: 100%;
	}

	.inputimg {
		display: flex;
		align-items: center;
		height: 1.2rem;
	}

	.inputimg img {
		width: 0.4rem;
		object-fit: cover;
	}

	.inputimg1 img {
		width: 0.453rem;
		object-fit: cover;
	}

	.van-form {
		border-radius: 0.2rem;
		overflow: hidden;
	}

	.van-cell {
		padding: 0;
		/* border-bottom: 1px solid #EBEBEB; */
	}

	.van-cell>>>.van-field__body {
		/* background: #F5F5F6 !important; */
		line-height: 1.2rem;
		padding-left: 0.3rem;
		/* border-radius: 0.6rem; */
		overflow: hidden;
	}

	.van-cell::after {
		display: none;
	}

	.van-hairline--bottom::after {
		display: none;
	}

	.van-nav-bar>>>.van-icon {
		color: #333333;
	}

	.send_code {
		border: 0px;
		border-radius: 0.426rem;
		color: #fafafa;
		font-size: 0.4rem;
		margin-bottom: 0.166rem;
	}

	.van-button--info {
		border: 0px;
		background: linear-gradient(180deg, #ff5457, #f90909);
	}

	.van-radio-group {
		display: flex;
		align-items: center;
	}

	.van-radio__icon {
		height: auto;
	}

	.wrapper {
		width: 7rem;
		margin: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.van-radio .van-radio__icon {
		height: auto;
	}

	.green_title {
		text-align: center;
		font-size: 0.5rem;
		line-height: 1rem;
	}

	.agreen_content {
		text-indent: 2em;
		font-size: 0.32rem;
		line-height: 0.6rem;
	}

	.green_wrap {
		padding: 0.3rem 0.4rem 0.4rem 0.4rem;
		background: #fff;
		border-radius: 0.2rem;
	}

	.btn {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.login {
		padding-top: 15px;
	}

	.wrap {
		/* background: url('../assets/images/login/login_bg.png') no-repeat; */
		background-position: 100% 0%;
		background-size: 60%;
		background-color: #fff !important;
		/* height: 100%; */
		min-height: 100%
	}

	.van-nav-bar {
		background: rgba(0, 0, 0, 0);
	}

	.van-field__control {
		font-size: 0.4rem;
	}

	/* 同意 */
	.consent {
		margin-top: 0.667rem;
		display: flex;
		align-items: center;
		color: #323232;
		font-size: 0.4rem;
	}

	.consentimg {
		display: flex;
		align-items: center;
	}

	.consent img {
		width: 0.453rem;
		object-fit: cover;
	}

	.agreement {
		color: #FF0000;
	}
</style>
